import {
  Box,
  Breadcrumbs,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  Chip,
  Stack,
  CircularProgress,
  Alert,
  Fade,
  IconButton,
  Tooltip,
  Switch,
  TableSortLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import api from "../../axiosInstance";
import { Link } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { toast, ToastContainer } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
// import DeleteConfirmationDialog from "./DeleteConfirmationDialog";
import { Checkbox, FormControlLabel, Menu } from "@mui/material";
import { useAuth } from ".././access/AuthContext";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import NotificationAddIcon from "@mui/icons-material/NotificationAdd";
import UpdateIcon from "@mui/icons-material/Update";
import NotificationModal from "../NotificationModal";
import UpdateSemesterModal from "./UpdateSemesterModal";
import useUniversitiesList from "../../hooks/useUniversitiesList";
import FilterBar from "../Reusable/FilterBar";

function AllUsers() {
  const { user } = useAuth;
  const [openNew, setOpenNew] = useState(false);
  const handleNewClose = () => setOpenNew(false);
  const [openUpdateSemester, setOpenUpdateSemester] = useState(false);
  const handleUpdateSemesterOpen = () => setOpenUpdateSemester(true);
  const handleUpdateSemesterClose = () => setOpenUpdateSemester(false);
  const [userList, setUserList] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(50);
  const [totalElements, setTotalElements] = useState(0);

  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState(() => {
    return localStorage.getItem("Users_management") || "";
  });

  const [dense, setDense] = useState(true);
  const [orderBy, setOrderBy] = useState("title");
  const [order, setOrder] = useState("asc");
  const [pushnotifications, setPushnotifications] = useState([]);
  const [universityId, setUniversityId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [semesterId, setSemesterId] = useState("");
  const [regulationId, setRegulationId] = useState("");
  const [purchaseStatus, setPurchaseStatus] = useState("ALL");
  const [filtersLoaded, setFiltersLoaded] = useState(false);
  const { universityList, courses, semesters, regulations, loading } =
    useUniversitiesList({});
  console.log(universityList);

  //   All UniversityList Api Fetching
  // useEffect(() => {
  //   api
  //     .get("/getAllUniversities")
  //     .then((res) => setUniversityList(res.data.data))
  //     .catch((err) => console.error(err));
  // }, []);
  // Sorting logic
  const handleSort = (columnKey) => {
    const isAsc = orderBy === columnKey && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(columnKey);
  };

  const sortedData = useMemo(() => {
    if (!Array.isArray(userList)) return [];
    if (!orderBy) return userList;
    return [...userList].sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];
      if (aValue < bValue) return order === "asc" ? -1 : 1;
      if (aValue > bValue) return order === "asc" ? 1 : -1;
      return 0;
    });
  }, [userList, order, orderBy]);

  // padding Dense
  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  // Deletion confirm dialog box open and close.
  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedId(null);
  };
  // Column config and visibility state
  const allColumns = [
    {
      key: "id",
      label: "ID",
      filterable: true,
      cellCss: { minWidth: "80px" },
      getValue: (r) => r.id,
    },
    {
      key: "collegeId",
      label: "College ID",
      filterable: false,
      cellCss: { minWidth: "120px" },
      getValue: (r) => r.collegeId ?? "-",
    },
    {
      key: "semesterId",
      label: "Semester ID",
      filterable: false,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.semesterId ?? "-",
    },

    {
      key: "deviceId",
      label: "Device ID",
      filterable: false,
      cellCss: { minWidth: "120px" },
      getValue: (r) => r.deviceId ?? "-",
    },
    {
      key: "name",
      label: "Name",
      filterable: true,
      cellCss: { minWidth: "120px" },
      getValue: (r) => r.name,
    },
    {
      key: "email",
      label: "Email",
      filterable: true,
      cellCss: { minWidth: "120px" },
      getValue: (r) => r.email,
    },
    {
      key: "universityName",
      label: "University ",
      filterable: false,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.universityName ?? "-",
    },

    {
      key: "courseName",
      label: "Course Name",
      filterable: false,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.courseName ?? "-",
    },
    {
      key: "semesterName",
      label: "Semester Name",
      filterable: false,
      cellCss: { minWidth: "170px" },
      getValue: (r) => r.semesterName ?? "-",
    },
    {
      key: "regulationYear",
      label: "Regulation Year",
      filterable: false,
      cellCss: { minWidth: "160px" },
      getValue: (r) => r.regulationYear ?? "-",
    },
    {
      key: "collegeName",
      label: "College Name ",
      filterable: true,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.collegeName ?? "-",
    },
    {
      key: "countryCode",
      label: "Country Code ",
      filterable: false,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.countryCode,
    },
    {
      key: "phoneNumber",
      label: "Phone Number",
      filterable: true,
      cellCss: { minWidth: "160px" },
      getValue: (r) => r.phoneNumber,
    },
    {
      key: "dateJoined",
      label: "Date Joined",
      filterable: true,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.dateJoined || "-",
    },

    {
      key: "referralCode",
      label: "Referral Code",
      filterable: true,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.referralCode,
    },
    {
      key: "userType",
      label: "User Type",
      filterable: false,
      cellCss: { minWidth: "120px" },
      getValue: (r) => r.userType,
    },
    {
      key: "deviceName",
      label: "Device Name",
      filterable: false,
      cellCss: { minWidth: "140px" },
      getValue: (r) => r.deviceName,
    },
    {
      key: "deviceOs",
      label: "Device Os",
      filterable: true,
      cellCss: { minWidth: "120px" },
      getValue: (r) => r.deviceOs,
    },
    {
      key: "roles",
      label: "Roles",
      filterable: false,
      cellCss: { minWidth: "100px" },
      getValue: (r) => r.roles,
    },
    {
      key: "stateName",
      label: "State Name",
      filterable: false,
      cellCss: { minWidth: "100px" },
      getValue: (r) => r.stateName,
    },
    {
      key: "creationDate",
      label: "Creation Date",
      filterable: false,
      getValue: (r) => r.creationDate,
    },
    {
      key: "lastUpdationDate",
      label: "Last Updation Date",
      filterable: false,
      cellCss: { minWidth: "200px" },
      getValue: (r) => r.lastUpdationDate,
    },
    {
      key: "active",
      label: "Active",
      cellCss: { minWidth: "100px" },
      filterable: false,
      getValue: (r) => (r.active ? "Yes" : "No"),
    },
  ];
  const defaultVisibleKeys = new Set([
    "id",
    "name",
    "email",
    "purchased",
    "phoneNumber",
    "dateJoined",
    "semesterId",
    "semesterName",
    "universityName",
    "courseName",
    "regulationYear",
    "referralCode",
    "userType",
  ]);

  const STORAGE_KEY = "AllUsersVisibleColumns";

  // Load saved filters from localStorage
  const savedFilters =
    JSON.parse(localStorage.getItem("usersColumnFilters")) || {};
  // Initialize column filters
  const [columnFilters, setColumnFilters] = useState(savedFilters);

  // Tracks which filter input is open per column
  const [filterOpen, setFilterOpen] = useState(() =>
    allColumns.reduce((acc, col) => {
      const key = col.key || col.id;
      acc[key] = !!savedFilters[key];
      return acc;
    }, {})
  );

  // Save to localStorage whenever it changes
  useEffect(() => {
    const savedFilters = JSON.parse(localStorage.getItem("usersColumnFilters"));
    if (savedFilters) {
      setColumnFilters((prev) => ({ ...prev, ...savedFilters }));
    }
  }, []);
  // Save filters to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("usersColumnFilters", JSON.stringify(columnFilters));
  }, [columnFilters]);

  const handleColumnFilterChange = (colKey, value) => {
    // Store the raw string so input works
    setColumnFilters((prev) => ({
      ...prev,
      [colKey]: value?.trim?.() ?? value ?? "",
    }));

    // If the input is not empty, keep the filter open
    if (value.trim() !== "") {
      setFilterOpen((prev) => ({ ...prev, [colKey]: true }));
    }
  };
  // Filter Icon toggle
  const toggleFilter = (colKey) => {
    setFilterOpen((prev) => ({
      ...prev,
      [colKey]: !prev[colKey], // toggle only this column
    }));
  };
  const filteredData = sortedData.filter((row) => {
    return Object.entries(columnFilters).every(([key, value]) => {
      if (!value?.trim()) return true; // Skip empty filters

      const cellValue = row[key];
      if (!cellValue) return false;

      //  Handle Date Joined (or any field containing "date")
      if (key === "dateJoined" || key.toLowerCase().includes("date")) {
        // Normalize both sides for comparison
        const formattedCell = cellValue.toString().toLowerCase(); // "2024-07-21"
        const searchTerm = value.toLowerCase();

        // Allow partial matching: "2024", "07", "21", etc.
        return formattedCell.includes(searchTerm);
      }
      // Default: regular string search for all other columns
      return cellValue.toString().toLowerCase().includes(value.toLowerCase());
    });
  });

  // Initialize from localStorage synchronously to avoid a race with the persister effect
  const [visibleColumns, setVisibleColumns] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          const validKeys = new Set(allColumns.map((c) => c.key));
          const filtered = arr.filter((k) => validKeys.has(k));
          if (filtered.length > 0) {
            return new Set(filtered);
          }
        }
      }
    } catch {}
    return new Set(Array.from(defaultVisibleKeys));
  });

  const [columnsMenuAnchor, setColumnsMenuAnchor] = useState(null);
  const openColumnsMenu = Boolean(columnsMenuAnchor);

  // Persist column config to localStorage on change
  useEffect(() => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(Array.from(visibleColumns))
      );
    } catch {}
  }, [visibleColumns]);

  const handleOpenColumnsMenu = (e) => setColumnsMenuAnchor(e.currentTarget);
  const handleCloseColumnsMenu = () => setColumnsMenuAnchor(null);
  const toggleColumn = (key) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  // Helper function to get boolean chip styling
  const getBooleanChip = (value) => {
    return (
      <Chip
        label={value ? "Yes" : "No"}
        color={value ? "success" : "error"}
        size="small"
        variant="outlined"
      />
    );
  };
  // Helper function to get boolean chip styling
  const getPurchasedChip = (value) => {
    if (!value) return "-";

    const normalized = value.toLowerCase();

    if (normalized.includes("not")) {
      return (
        <Chip
          label="Not Purchased"
          color="error"
          size="small"
          variant="outlined"
        />
      );
    } else if (normalized.includes("purchased")) {
      return (
        <Chip
          label="Purchased"
          color="success"
          size="small"
          variant="outlined"
        />
      );
    }

    return <Chip label={value} size="small" variant="outlined" />;
  };

  // Helper function to get discount type chip styling
  const getDiscountTypeChip = (type) => {
    const typeConfig = {
      percentage: { color: "primary", label: "Percentage" },
      fixed: { color: "secondary", label: "Fixed" },
      free: { color: "success", label: "Free" },
    };

    const config = typeConfig[type?.toLowerCase()] || {
      color: "default",
      label: type || "Unknown",
    };
    return <Chip label={config.label} color={config.color} size="small" />;
  };

  // Debounce effect: wait 500ms after typing before triggering API
  const [debouncedSearch, setDebouncedSearch] = useState(
    columnFilters?.name ||
      columnFilters?.id ||
      columnFilters?.referralCode ||
      columnFilters?.courseName ||
      columnFilters?.collegeName ||
      columnFilters?.semesterName ||
      columnFilters?.regulationYear ||
      columnFilters?.dateJoined ||
      columnFilters?.deviceOs ||
      columnFilters?.phoneNumber ||
      columnFilters?.email ||
      ""
  );
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(
        columnFilters?.name ||
          columnFilters?.id ||
          columnFilters?.referralCode ||
          columnFilters?.courseName ||
          columnFilters?.collegeName ||
          columnFilters?.semesterName ||
          columnFilters?.regulationYear ||
          columnFilters?.dateJoined ||
          columnFilters?.deviceOs ||
          columnFilters?.phoneNumber ||
          columnFilters?.email ||
          ""
      );
    }, 500);

    return () => clearTimeout(handler);
  }, [columnFilters]);

  // Fetch paged all users data whenever page/rowsPerPage changes
  useEffect(() => {
    if (!filtersLoaded) return;
    setIsLoading(true);
    setError(null);
    const params = {
      page,
      size: rowsPerPage,
      search: debouncedSearch,
      universityId: universityId,
      courseId: courseId,
      regulationId: regulationId,
      semesterId: semesterId,
    };

    // Only include purchaseStatus if it's not "ALL" (default behavior)
    if (purchaseStatus && purchaseStatus !== "ALL") {
      params.purchaseStatus = purchaseStatus;
    }

    api
      .get("/api/userDetails/getAllUserDetails", {
        params,
      })
      .then((res) => {
        const data = res.data;
        console.log(data);

        setUserList(Array.isArray(data?.content) ? data.content : []);
        setTotalElements(
          typeof data?.totalElements === "number" ? data.totalElements : 0
        );
        setError(null);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load Users. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [
    page,
    rowsPerPage,
    debouncedSearch,
    universityId,
    courseId,
    semesterId,
    regulationId,
    purchaseStatus,
    filtersLoaded,
  ]);

  //   Page nation handel changes
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // page nation rows handles
  const handleChangeRowsPerPage = (event) => {
    const next = parseInt(event.target.value);
    setRowsPerPage(next);
    setPage(0);
  };

  const visibleColumnDefs = allColumns.filter((c) => visibleColumns.has(c.key));

  // opening Adding page data in onclick
  const handleNewOpen = () => {
    setOpenNew(true);
  };
  // chekck  box selected ids
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = filteredData.map((row) => row.id);
      setPushnotifications(allIds);
    } else {
      setPushnotifications([]);
    }
  };

  const handleRowSelect = (id) => {
    setPushnotifications((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const isSelected = (id) => pushnotifications.includes(id);

  // Restore filters on mount
  useEffect(() => {
    const savedFilters = JSON.parse(localStorage.getItem("userFilters"));
    if (savedFilters) {
      setUniversityId(savedFilters.universityId || "");
      setCourseId(savedFilters.courseId || "");
      setSemesterId(savedFilters.semesterId || "");
      setRegulationId(savedFilters.regulationId || "");
      setPurchaseStatus(savedFilters.purchaseStatus || "ALL");
    }
    setFiltersLoaded(true);
  }, []);

  // Save filters whenever they change
  useEffect(() => {
    if (!filtersLoaded) return;
    const filters = {
      universityId,
      courseId,
      semesterId,
      regulationId,
      purchaseStatus,
    };
    localStorage.setItem("userFilters", JSON.stringify(filters));
  }, [
    filtersLoaded,
    universityId,
    courseId,
    semesterId,
    regulationId,
    purchaseStatus,
  ]);
  // reset the Local saved filters
  const [rotating, setRotating] = useState(false);
  const handleResetFilters = () => {
    setUniversityId("");
    setCourseId("");
    setSemesterId("");
    setRegulationId("");
    setPurchaseStatus("ALL");
    localStorage.removeItem("userFilters");
  };
  const handleClick = () => {
    setRotating(true);
    handleResetFilters?.();

    // Stop rotation after animation completes
    setTimeout(() => setRotating(false), 600); // match animation duration
  };
  return (
    <>
      <Box>
        <ToastContainer />

        {/* Search Section */}
        <Card sx={{ boxShadow: 1 }}>
          <CardContent>
            <Box
              sx={{
                display: { xs: "block", md: "flex" },
                gap: 2,
              }}
            >
              <FilterBar
                universityId={universityId}
                courseId={courseId}
                semesterId={semesterId}
                regulationId={regulationId}
                setUniversityId={setUniversityId}
                setCourseId={setCourseId}
                setSemesterId={setSemesterId}
                setRegulationId={setRegulationId}
              />
              <Stack
                direction="row"
                sx={{
                  width: { md: "16%", xs: "100%" },
                  marginTop: { md: "0", xs: "10px" },
                }}
                spacing={2}
                flexWrap="wrap"
                useFlexGap
              >
                <FormControl
                  size="small"
                  sx={{
                    minWidth: { md: 180, xs: "100%" },
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    marginTop: { xs: "5px", md: "0px" },
                  }}
                >
                  <InputLabel>Purchase Status</InputLabel>
                  <Select
                    value={purchaseStatus}
                    onChange={(e) => setPurchaseStatus(e.target.value)}
                    label="Purchase Status"
                    sx={{
                      textAlign: "left",
                    }}
                  >
                    <MenuItem value="ALL">All Users</MenuItem>
                    <MenuItem value="PURCHASED">Purchased</MenuItem>
                    <MenuItem value="NOT_PURCHASED">Not Purchased</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
              <Button
                onClick={handleClick}
                variant="outlined"
                sx={{
                  display: { xs: "none", md: "flex" },
                  minWidth: "20px",
                  padding: "4px 4px",
                  borderRadius: "10px",
                  fontWeight: 600,
                  textTransform: "none",
                  color: "#17479e",
                  borderColor: "#17479e",
                  backgroundColor: "#f8f9ff",
                  transition: "all 0.3s ease",
                  boxShadow: "0 0 0 rgba(0,0,0,0)",
                  "&:hover": {
                    backgroundColor: "#17479e",
                    color: "#fff",
                    borderColor: "#17479e",
                    transform: "scale(1.05)",
                    boxShadow: "0 3px 10px rgba(25, 118, 210, 0.3)",
                  },
                  "&:active": {
                    transform: "scale(0.98)",
                  },
                }}
              >
                <RefreshIcon
                  sx={{
                    animation: rotating ? "spin 0.6s linear" : "none",
                    "@keyframes spin": {
                      "0%": { transform: "rotate(0deg)" },
                      "100%": { transform: "rotate(360deg)" },
                    },
                  }}
                />
              </Button>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: { md: "10px", xs: "0" },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "flex-start", md: "center" },
                  gap: 2,
                }}
              >
                <Typography
                  sx={{ ml: { xs: 0.5, md: 1 } }}
                  variant="body2"
                  color="text.secondary"
                >
                  {filteredData.length} of {totalElements} Users
                </Typography>
              </Box>
              <Box
                sx={{
                  display: { md: "flex", xs: "none" },
                  flexWrap: "wrap",
                  justifyContent: { xs: "center", md: "flex-end" },
                  gap: 1.5,
                  flexGrow: 1,
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<ViewColumnIcon />}
                  onClick={handleOpenColumnsMenu}
                  sx={{
                    fontSize: { xs: "10px", md: "12px" },
                  }}
                >
                  Columns
                </Button>
                <Menu
                  anchorEl={columnsMenuAnchor}
                  open={openColumnsMenu}
                  onClose={handleCloseColumnsMenu}
                  PaperProps={{
                    sx: {
                      width: 250,
                      maxHeight: 500,
                      overflowY: "auto",
                    },
                  }}
                >
                  {allColumns.map((col) => (
                    <FormControlLabel
                      key={col.key}
                      control={
                        <Checkbox
                          checked={visibleColumns.has(col.key)}
                          onChange={() => toggleColumn(col.key)}
                        />
                      }
                      label={col.label}
                      sx={{ pl: 1, pr: 2 }}
                    />
                  ))}
                </Menu>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<NotificationAddIcon />}
                  onClick={handleNewOpen}
                  sx={{
                    fontSize: { xs: "10px", md: "12px" },
                  }}
                >
                  Push Notifications
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<UpdateIcon />}
                  onClick={handleUpdateSemesterOpen}
                  sx={{
                    fontSize: { xs: "10px", md: "12px" },
                  }}
                >
                  Update Semester
                </Button>
                <Tooltip title="Dense padding" arrow>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={dense}
                        onChange={handleChangeDense}
                        color="primary"
                      />
                    }
                  />
                </Tooltip>
              </Box>
              <Tooltip
                sx={{ display: { xs: "flex", md: "none" } }}
                title="Dense padding"
                arrow
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={dense}
                      onChange={handleChangeDense}
                      color="primary"
                    />
                  }
                />
              </Tooltip>
            </Box>

            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                flexWrap: "wrap",
                justifyContent: { xs: "center", md: "flex-end" },
                gap: 1.5,
              }}
            >
              <Button
                onClick={handleClick}
                variant="outlined"
                sx={{
                  minWidth: "24px",
                  padding: "6px 6px",
                  borderRadius: "10px",
                  fontWeight: 600,
                  textTransform: "none",
                  color: "#17479e",
                  borderColor: "#17479e",
                  backgroundColor: "#f8f9ff",
                  transition: "all 0.3s ease",
                  boxShadow: "0 0 0 rgba(0,0,0,0)",
                  "&:hover": {
                    backgroundColor: "#17479e",
                    color: "#fff",
                    borderColor: "#17479e",
                    transform: "scale(1.05)",
                    boxShadow: "0 3px 10px rgba(25, 118, 210, 0.3)",
                  },
                  "&:active": {
                    transform: "scale(0.98)",
                  },
                }}
              >
                <RefreshIcon
                  sx={{
                    animation: rotating ? "spin 0.6s linear" : "none",
                    "@keyframes spin": {
                      "0%": { transform: "rotate(0deg)" },
                      "100%": { transform: "rotate(360deg)" },
                    },
                  }}
                />
              </Button>
              <Button
                variant="outlined"
                startIcon={<ViewColumnIcon />}
                onClick={handleOpenColumnsMenu}
                sx={{
                  fontSize: { xs: "10px", md: "12px" },
                }}
              >
                Columns
              </Button>
              <Menu
                anchorEl={columnsMenuAnchor}
                open={openColumnsMenu}
                onClose={handleCloseColumnsMenu}
                PaperProps={{
                  sx: {
                    width: 250,
                    maxHeight: 500,
                    overflowY: "auto",
                  },
                }}
              >
                {allColumns.map((col) => (
                  <FormControlLabel
                    key={col.key}
                    control={
                      <Checkbox
                        checked={visibleColumns.has(col.key)}
                        onChange={() => toggleColumn(col.key)}
                      />
                    }
                    label={col.label}
                    sx={{ pl: 1, pr: 2 }}
                  />
                ))}
              </Menu>
              <Button
                variant="contained"
                color="primary"
                startIcon={<NotificationAddIcon />}
                onClick={handleNewOpen}
                sx={{
                  fontSize: { xs: "10px", md: "12px" },
                }}
              >
                Push Notifications
              </Button>
              {/* Dense toggle */}
            </Box>
          </CardContent>
        </Card>

        {/* Error State */}
        {error && (
          <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        {/* Loading State */}
        {isLoading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
            <CircularProgress />
          </Box>
        )}
        {/* Table Section */}
        {!isLoading && (
          <Fade in={!isLoading}>
            <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: 2 }}>
              <TableContainer sx={{ maxHeight: 600 }}>
                <Table
                  stickyHeader
                  aria-label="coupons table"
                  size={dense ? "small" : "medium"}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        padding="checkbox"
                        sx={{
                          backgroundColor: "#17479e",
                          color: "white",
                          position: "sticky",
                          top: 0,
                          zIndex: 3,
                        }}
                      >
                        <Checkbox
                          color="primary"
                          checked={
                            filteredData.length > 0 &&
                            pushnotifications.length === filteredData.length
                          }
                          indeterminate={
                            pushnotifications.length > 0 &&
                            pushnotifications.length < filteredData.length
                          }
                          onChange={handleSelectAll}
                          sx={{
                            color: "white",
                            "&.Mui-checked": { color: "white" },
                          }}
                        />
                      </TableCell>
                      {visibleColumnDefs.map((c) => (
                        <TableCell
                          key={c.key}
                          sx={{
                            backgroundColor: "#17479e",
                            padding: "10px 5px ",
                            color: "white",
                            fontWeight: 600,
                            ...c.cellCss,
                            position: "sticky",
                            top: 0,
                            zIndex: 3,
                          }}
                          sortDirection={orderBy === c.key ? order : false}
                        >
                          <TableSortLabel
                            active={orderBy === c.key}
                            direction={orderBy === c.key ? order : "asc"}
                            onClick={() => handleSort(c.key)}
                            sx={{
                              color: "#ffffff !important",
                              "&.Mui-active": {
                                color: "#ffffff !important",
                              },
                              "& .MuiTableSortLabel-icon": {
                                color: "#ffffff !important",
                              },
                            }}
                          >
                            {c.label}
                          </TableSortLabel>

                          {c.filterable && (
                            <IconButton
                              size="small"
                              onClick={() => toggleFilter(c.key)}
                              sx={{ color: "#fff" }}
                            >
                              {filterOpen[c.key] ? (
                                <FilterListOffIcon sx={{ fontSize: "14px" }} />
                              ) : (
                                <FilterListIcon sx={{ fontSize: "14px" }} />
                              )}
                            </IconButton>
                          )}
                          {filterOpen[c.key] &&
                            ![
                              "semesterName",
                              "universityName",
                              "courseName",
                              "regulationYear",
                            ].includes(c.key) && (
                              <TextField
                                size="small"
                                variant="outlined"
                                placeholder={
                                  c.label === "Date Joined"
                                    ? "YYYY-MM-DD"
                                    : `Search ${c.label}`
                                }
                                value={columnFilters[c.key]}
                                onChange={(e) =>
                                  handleColumnFilterChange(
                                    c.key,
                                    e.target.value
                                  )
                                }
                                sx={{
                                  mt: 1,
                                  width: "100%",
                                  "& .MuiInputBase-root": {
                                    minHeight: "15px",
                                    color: "#fff",
                                    "& fieldset": {
                                      borderColor: "#ffffffff",
                                    },
                                    "&:hover fieldset": {
                                      borderColor: "#ffffffff",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "#ffffffff",
                                    },
                                  },
                                  "& .MuiOutlinedInput-input": {
                                    py: 0.5,
                                  },
                                }}
                              />
                            )}
                        </TableCell>
                      ))}
                      {/* <TableCell
                        sx={{
                          backgroundColor: "#17479e",
                          color: "white",
                          fontWeight: 600,
                          minWidth: 120,
                        }}
                      >
                        Actions
                      </TableCell> */}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {console.log(filteredData)}
                    {Array.isArray(filteredData) && filteredData.length > 0 ? (
                      filteredData.map((row) => {
                        const selected = isSelected(row.id);
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id}
                            sx={{
                              "&:nth-of-type(odd)": {
                                backgroundColor: "rgba(0, 0, 0, 0.02)",
                              },
                              "&:hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.04)",
                              },
                            }}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                color="primary"
                                checked={selected}
                                sx={{
                                  color: "#17479e",
                                  "&.Mui-checked": { color: "#17479e" },
                                }}
                                onChange={() => handleRowSelect(row.id)}
                              />
                            </TableCell>

                            {visibleColumnDefs.map((c) => (
                              <TableCell
                                key={c.key}
                                sx={{
                                  padding: "5px 5px",
                                  align: "center",
                                  ...c.cellCss,
                                }}
                              >
                                {c.key === "isCollegeSpecific" ||
                                c.key === "discountType"
                                  ? getDiscountTypeChip(c.getValue(row))
                                  : c.getValue(row)}
                              </TableCell>
                            ))}
                            {/* <TableCell
                            sx={{
                              align: "center",
                              padding: "10px ",
                              minWidth: "120px",
                            }}
                          >
                            <Stack
                              direction="row"
                              spacing={0.5}
                              justifyContent="center"
                            >
                              <Tooltip
                                title="Edit Coupon"
                                arrow
                                placement="top"
                              >
                                <IconButton
                                  color="primary"
                                  onClick={() => handleEditClick(row)}
                                  size="small"
                                  sx={{
                                    "&:hover": {
                                      backgroundColor: "primary.light",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                title="Delete Coupon"
                                arrow
                                placement="top"
                              >
                                <IconButton
                                  color="error"
                                  onClick={() => handleClickOpen(row.id)}
                                  size="small"
                                  sx={{
                                    "&:hover": {
                                      backgroundColor: "error.light",
                                      color: "white",
                                    },
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Stack>
                          </TableCell> */}
                          </TableRow>
                        );
                      })
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={visibleColumnDefs.length + 1}
                          sx={{ textAlign: "center", py: 4 }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 2,
                            }}
                          >
                            <Typography variant="h6" color="text.secondary">
                              {searchQuery
                                ? "No Users found matching your search"
                                : "No Users available"}
                            </Typography>
                            {searchQuery && (
                              <Button
                                variant="outlined"
                                onClick={() => setSearchQuery("")}
                                startIcon={<SearchIcon />}
                              >
                                Clear Search
                              </Button>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 30, 50, 100, 200, 500, 1000]}
                component="div"
                count={totalElements}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  borderTop: "1px solid",
                  borderColor: "divider",
                  "& .MuiTablePagination-toolbar": {
                    paddingLeft: 2,
                    paddingRight: 2,
                  },
                }}
              />
            </Paper>
          </Fade>
        )}

        <NotificationModal
          // newsEdit={newsEdit}
          selectedUsersNotifications={pushnotifications || []}
          open={openNew}
          onClose={handleNewClose}
          // onSuccess={handleFormSuccess}
        />
        <UpdateSemesterModal
          open={openUpdateSemester}
          onClose={handleUpdateSemesterClose}
        />
        {/* Confirm Delete Dialog */}
        {/* <DeleteConfirmationDialog
          open={open}
          onClose={handleClose}
          onConfirm={handleDelete}
          title="Confirm Delete"
          message="Are you sure you want to delete this coupon? This action cannot be undone."
          confirmText="DELETE"
          confirmButtonText="Delete"
          cancelButtonText="Cancel"
        /> */}
      </Box>
    </>
  );
}

export default AllUsers;
